/* SIGNORA — Gallery: The Light Table & the Loupe.
   Reads window.SJWGAL (exposed by sjw-product-page.liquid) and listens for the
   'sjw:gal' bridge event. The server marks the selected gallery with .sjw-lt-on;
   failed initialization raises .sjw-lt-failed so the shipping fallback returns. */
(function () {
  'use strict';
  var RM = window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches;
  var EASE = 'cubic-bezier(.22,.61,.36,1)';
  function desk() { return window.innerWidth >= 821; }
  function el(tag, cls, html) { var d = document.createElement(tag); if (cls) d.className = cls; if (html != null) d.innerHTML = html; return d; }

  function ready(fn) { if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', fn); } else { fn(); } }
  ready(function () {
    var tries = 0;
    (function wait() {
      if (window.SJWGAL && window.SJWGAL.media && window.SJWGAL.media.length) { init(window.SJWGAL); }
      else if (++tries < 100) { setTimeout(wait, 60); }
      else { document.documentElement.classList.add('sjw-lt-failed'); }
    })();
  });

  function init(G) {
    var main2 = document.querySelector('.sjwpp-main2'); if (!main2) return;
    var gcol = main2.querySelector(':scope > .sjwpp-gcol:first-child');
    var bcol = main2.querySelector(':scope > .sjwpp-gcol:last-child');
    var gal = gcol && gcol.querySelector('.sjwpp-gal');
    var stage = gcol && gcol.querySelector('[data-sjwpp-stage]');
    var mainImg = gcol && gcol.querySelector('[data-sjwpp-mainimg]');
    if (!gcol || !gal || !stage || !mainImg) return;
    var M = G.media;
    var VM = G.videos || [];

    /* ---------- photo set (mirrors theme showColor) ---------- */
    var SET = M.slice(), VIEW = M.slice(), HONEST = true; /* HONEST=false → color chosen but never photographed */
    var VARIANT_LINKED = !!(G.state && G.state().variantMediaLinked);
    function setKey() { return SET.map(function (m) { return m.m; }).join('|'); }
    function computeSet() {
      var st = G.state ? G.state() : { color: '', all: false };
      var g = [];
      HONEST = true;
      if (!st.all && st.color) {
        var any = M.some(function (m) { return m.c === st.color; });
        if (any) { g = M.filter(function (m) { return m.c === st.color || !m.c; }); }
        else { HONEST = false; }
      }
      if (!g.length) g = M.slice();
      SET = g;
    }
    computeSet();

    /* ================= PRODUCT FILM (desktop) ================= */
    var productNoun = String(G.productNoun || 'piece').toLowerCase();
    var motionCopy = 'See the ' + productNoun + ' in motion';
    var vp = null, vpStage = null, vpClose = null, vpBack = null, vpLastFocus = null, vpReturnPhoto = null, vpIdx = 0, vpCounter = null, vpRail = null, vpPrev = null, vpNext = null, vpPaint = 0, posterToneCache = {};
    function detectLightPoster(src, done) {
      if (!src) { done(false); return; }
      if (Object.prototype.hasOwnProperty.call(posterToneCache, src)) { done(posterToneCache[src]); return; }
      var im = new Image();
      im.crossOrigin = 'anonymous';
      im.onload = function () {
        var light = false;
        try {
          var c = document.createElement('canvas'), n = 24, ctx = c.getContext('2d', { willReadFrequently: true });
          c.width = c.height = n; ctx.drawImage(im, 0, 0, n, n);
          var data = ctx.getImageData(0, 0, n, n).data, sum = 0, bright = 0, samples = 0;
          for (var y = 0; y < n; y++) for (var x = 0; x < n; x++) {
            if (x > 5 && x < 18 && y > 5 && y < 18) continue;
            var p = (y * n + x) * 4, r = data[p], g = data[p + 1], b = data[p + 2];
            var lum = .2126 * r + .7152 * g + .0722 * b;
            sum += lum; if (lum > 218 && Math.max(r, g, b) - Math.min(r, g, b) < 34) bright++; samples++;
          }
          light = samples > 0 && (sum / samples) > 200 && (bright / samples) > .48;
        } catch (_e) {}
        posterToneCache[src] = light; done(light);
      };
      im.onerror = function () { posterToneCache[src] = false; done(false); };
      im.src = src;
    }
    window.SJW_GALLERY_POSTER_TONE = detectLightPoster;
    function hardenVideo(v) {
      if (!v) return;
      v.controls = false;
      v.removeAttribute('controls');
      v.setAttribute('controlsList', 'nodownload noplaybackrate noremoteplayback');
      v.setAttribute('disablePictureInPicture', '');
      v.setAttribute('disableRemotePlayback', '');
      v.setAttribute('playsinline', '');
      v.disablePictureInPicture = true;
      v.disableRemotePlayback = true;
      v.preload = 'auto';
      v.addEventListener('contextmenu', function (e) { e.preventDefault(); });
    }
    function buildVideoPlayer() {
      if (vp) return;
      vp = el('div', 'sjwlt-vp');
      vp.setAttribute('role', 'dialog');
      vp.setAttribute('aria-modal', 'true');
      vp.setAttribute('aria-label', 'Product film');
      vp.innerHTML =
        '<div class="sjwlt-vp-card">' +
          '<div class="sjwlt-vp-head"><button type="button" class="sjwlt-vp-back" aria-label="Back to product photos"><span aria-hidden="true">&#8592;</span> Photos</button><span class="sjwlt-vp-title"><b>Signora</b> Product Film <i class="sjwlt-vp-counter"></i></span><button type="button" class="sjwlt-vp-x" aria-label="Close product film"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button></div>' +
          '<div class="sjwlt-vp-stage"><button type="button" class="sjwlt-vp-nav sjwlt-vp-prev" aria-label="Previous product film">&#8249;</button><div class="sjwlt-vp-media"></div><button type="button" class="sjwlt-vp-nav sjwlt-vp-next" aria-label="Next product film">&#8250;</button></div>' +
          '<div class="sjwlt-vp-rail" role="tablist" aria-label="Product films"></div>' +
          '<div class="sjwlt-vp-foot"><span>' + motionCopy + '</span><span>Made to order in Surat</span></div>' +
        '</div>';
      document.body.appendChild(vp);
      vpStage = vp.querySelector('.sjwlt-vp-media');
      vpCounter = vp.querySelector('.sjwlt-vp-counter');
      vpRail = vp.querySelector('.sjwlt-vp-rail');
      vpPrev = vp.querySelector('.sjwlt-vp-prev');
      vpNext = vp.querySelector('.sjwlt-vp-next');
      vpBack = vp.querySelector('.sjwlt-vp-back');
      vpClose = vp.querySelector('.sjwlt-vp-x');
      vpBack.addEventListener('click', returnToPhotos);
      vpClose.addEventListener('click', closeVideoPlayer);
      vpPrev.addEventListener('click', function () { showVideoAt(vpIdx - 1); });
      vpNext.addEventListener('click', function () { showVideoAt(vpIdx + 1); });
      vp.addEventListener('click', function (e) { if (e.target === vp) closeVideoPlayer(); });
      vp.addEventListener('contextmenu', function (e) { e.preventDefault(); }, true);
      document.addEventListener('keydown', function (e) {
        if (!vp.classList.contains('open')) return;
        if (e.key === 'Escape') { closeVideoPlayer(); }
        else if (e.key === 'ArrowLeft' && VM.length > 1) { e.preventDefault(); showVideoAt(vpIdx - 1); }
        else if (e.key === 'ArrowRight' && VM.length > 1) { e.preventDefault(); showVideoAt(vpIdx + 1); }
      });
    }
    function renderVideoRail() {
      if (!vpRail) return;
      vpRail.innerHTML = '';
      if (VM.length < 2) { vpRail.hidden = true; return; }
      vpRail.hidden = false;
      VM.forEach(function (m, i) {
        var b = el('button', 'sjwlt-vp-thumb' + (i === vpIdx ? ' on' : ''));
        b.type = 'button';
        b.setAttribute('role', 'tab');
        b.setAttribute('aria-selected', i === vpIdx ? 'true' : 'false');
        b.setAttribute('aria-label', 'Play product film ' + (i + 1) + ' of ' + VM.length);
        b.innerHTML = '<img src="' + (m.t || m.g || m.m || '') + '" alt=""><span>Film ' + (i + 1) + '</span>';
        b.addEventListener('click', function () { showVideoAt(i); });
        vpRail.appendChild(b);
      });
    }
    function showVideoAt(i) {
      if (!VM.length || !vpStage) return;
      if (i < 0) i = VM.length - 1;
      if (i >= VM.length) i = 0;
      vpIdx = i;
      var m = VM[i], paint = ++vpPaint;
      var toneSrc = m.g || m.m || m.t || '';
      if (Object.prototype.hasOwnProperty.call(posterToneCache, toneSrc)) {
        vp.classList.toggle('sjwlt-vp--light', posterToneCache[toneSrc]);
      } else {
        detectLightPoster(toneSrc, function (isLight) { if (vp && vpIdx === i && paint === vpPaint) vp.classList.toggle('sjwlt-vp--light', isLight); });
      }
      var oldPane = vpStage.querySelector('.sjwlt-vp-pane.on');
      Array.prototype.forEach.call(vpStage.querySelectorAll('.sjwlt-vp-pane:not(.on)'), function (pending) {
        var pendingVideo = pending.querySelector('video');
        if (pendingVideo) { try { pendingVideo.pause(); } catch (_e) {} }
        pending.remove();
      });
      vpStage.style.setProperty('--sjw-video-poster', 'url("' + String(toneSrc).replace(/"/g, '%22') + '")');
      var pane = el('div', 'sjwlt-vp-pane');
      pane.innerHTML = m.h || '';
      var v = pane.querySelector('video');
      hardenVideo(v);
      vpStage.appendChild(pane);
      if (vpCounter) vpCounter.textContent = VM.length > 1 ? ((i + 1) + ' / ' + VM.length) : '';
      if (vpPrev) vpPrev.hidden = VM.length < 2;
      if (vpNext) vpNext.hidden = VM.length < 2;
      renderVideoRail();
      var revealed = false;
      function reveal() {
        if (revealed || paint !== vpPaint || !pane.parentNode) return;
        revealed = true;
        var oldVideo = oldPane && oldPane.querySelector('video');
        if (oldVideo) { try { oldVideo.pause(); } catch (_e) {} }
        window.requestAnimationFrame(function () {
          if (paint !== vpPaint || !pane.parentNode) return;
          pane.classList.add('on');
          if (oldPane && oldPane !== pane) {
            oldPane.classList.remove('on');
            window.setTimeout(function () { if (oldPane.parentNode) oldPane.remove(); }, 300);
          }
        });
      }
      if (v) {
        if (v.readyState >= 2) reveal();
        else {
          v.addEventListener('loadeddata', reveal, { once: true });
          v.addEventListener('canplay', reveal, { once: true });
          window.setTimeout(reveal, 900);
        }
        v.addEventListener('ended', function () {
          if (paint !== vpPaint) return;
          if (vpIdx < VM.length - 1) showVideoAt(vpIdx + 1);
          else closeVideoPlayer();
        }, { once: true });
        var p = v.play(); if (p && p.catch) p.catch(function () {});
      } else reveal();
    }
    function openVideoPlayer(m, index) {
      buildVideoPlayer();
      vpLastFocus = document.activeElement;
      if (!vpReturnPhoto || SET.indexOf(vpReturnPhoto) < 0) vpReturnPhoto = SET[idxOfStage()] || SET[0] || null;
      vp.classList.add('open');
      document.documentElement.classList.add('sjw-product-film-open');
      document.body.style.overflow = 'hidden';
      var found = typeof index === 'number' ? index : VM.indexOf(m);
      showVideoAt(found > -1 ? found : 0);
      vpClose.focus();
    }
    function closeVideoPlayer() {
      if (!vp) return;
      vpPaint++;
      Array.prototype.forEach.call(vpStage.querySelectorAll('video'), function (v) { try { v.pause(); } catch (_e) {} });
      vpStage.innerHTML = '';
      vpStage.style.removeProperty('--sjw-video-poster');
      vp.classList.remove('open');
      document.documentElement.classList.remove('sjw-product-film-open');
      document.body.style.overflow = '';
      if (vpLastFocus && vpLastFocus.focus) { try { vpLastFocus.focus(); } catch (_e) {} }
      vpReturnPhoto = null;
    }
    function returnToPhotos() {
      var returnIndex = vpReturnPhoto ? SET.indexOf(vpReturnPhoto) : idxOfStage();
      closeVideoPlayer();
      requestAnimationFrame(function () { openLp(returnIndex > -1 ? returnIndex : 0); });
    }
    function videoFrame(m, i, total) {
      var b = el('button', 'sjwlt-vfr');
      b.type = 'button';
      b.setAttribute('aria-label', 'Play product film' + (total > 1 ? ' ' + (i + 1) + ' of ' + total : ''));
      b.innerHTML =
        '<img class="sjwlt-vposter" alt="" draggable="false">' +
        '<span class="sjwlt-vshade"></span>' +
        '<span class="sjwlt-vcopy"><span class="sjwlt-vplay"><svg viewBox="0 0 18 18" aria-hidden="true"><path d="M6 4l8 5-8 5z"/></svg></span><span><small>Product Film' + (total > 1 ? ' ' + String(i + 1).padStart(2, '0') : '') + '</small><b>' + motionCopy + '</b></span><em>Play</em></span>';
      b.querySelector('img').src = m.g || m.m || m.t;
      b.addEventListener('click', function () { openVideoPlayer(m, i); });
      return b;
    }
    function videoCollection(items) {
      var set = el('section', 'sjwlt-vset');
      set.setAttribute('aria-label', 'Product films');
      set.innerHTML = '<div class="sjwlt-vset-head"><span><small>Product Films</small><b>' + items.length + ' views in motion</b></span><em>Select a film</em></div><div class="sjwlt-vset-grid"></div>';
      var grid = set.querySelector('.sjwlt-vset-grid');
      items.forEach(function (m, i) { var frame = videoFrame(m, i, items.length); frame.classList.add('sjwlt-vfr--multi'); grid.appendChild(frame); });
      return set;
    }

    function metalBtn() { return document.querySelector('[data-sjwpp-gview-btn="metal"]'); }
    function metalLabel() { var b = metalBtn(); var t = b && (b.textContent || '').trim(); return t; }
    function metalDotColor() { var b = metalBtn(); return (b && b.style.getPropertyValue('--sjwdot')) || '#d4af37'; }

    /* ================= THE LOUPE (all viewports) ================= */
    var lp = null, lpImg, lpCap, lpFilm, lpStage, lpHint, lpX, lpFilmCta, lpIdx = 0, zoom = 1, panX = 0, panY = 0, lastFocus = null, hintShown = false;
    var lpCache = {}, lpPaint = 0;
    function loadLpImage(src, priority) {
      if (!src) return null;
      var rec = lpCache[src];
      if (rec) {
        if (priority === 'high' && 'fetchPriority' in rec.img) rec.img.fetchPriority = 'high';
        return rec;
      }
      rec = { img: new Image(), ready: false, failed: false, promise: null };
      var finish;
      rec.promise = new Promise(function (resolve) { finish = resolve; });
      rec.img.decoding = 'async';
      if ('fetchPriority' in rec.img) rec.img.fetchPriority = priority || 'auto';
      rec.img.onload = function () {
        var decoded = rec.img.decode ? rec.img.decode() : Promise.resolve();
        decoded.catch(function () {}).then(function () { rec.ready = true; finish(true); });
      };
      rec.img.onerror = function () { rec.failed = true; finish(false); };
      rec.img.src = src;
      lpCache[src] = rec;
      if (rec.img.complete && rec.img.naturalWidth) {
        rec.ready = true;
        finish(true);
      }
      return rec;
    }
    function primeLpAround(i) {
      var current = VIEW[i], next = VIEW[i + 1], prev = VIEW[i - 1];
      [current, next, prev].forEach(function (m, ix) {
        if (!m) return;
        loadLpImage(m.t || m.m || m.z, ix === 0 ? 'high' : 'auto');
        loadLpImage(m.m || m.g || m.t || m.z, ix < 2 ? 'high' : 'auto');
      });
      if (current) loadLpImage(current.z || current.m, 'high');
      var idle = window.requestIdleCallback || function (fn) { setTimeout(fn, 140); };
      idle(function () {
        [next, prev].forEach(function (m) { if (m) loadLpImage(m.z || m.m, 'auto'); });
      }, { timeout: 650 });
    }
    function buildLp() {
      if (lp) return;
      lp = el('div', 'sjwlt-lp');
      lp.setAttribute('role', 'dialog'); lp.setAttribute('aria-modal', 'true'); lp.setAttribute('aria-label', 'Product media viewer');
      lp.innerHTML =
        '<div class="sjwlt-lp-top"><span class="sjwlt-lp-cap"></span><button type="button" class="sjwlt-lp-x" aria-label="Close photo viewer"><svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" width="13" height="13" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg></button></div>' +
        '<div class="sjwlt-lp-stage"><button type="button" class="sjwlt-arr" data-d="-1" aria-label="Previous photo">&#8249;</button><img alt="" draggable="false"><button type="button" class="sjwlt-arr" data-d="1" aria-label="Next photo">&#8250;</button><button type="button" class="sjwlt-lp-filmnext" aria-label="Watch product films" hidden><span class="sjwlt-lp-filmnext-play"><svg viewBox="0 0 18 18" aria-hidden="true"><path d="M6 4l8 5-8 5z"/></svg></span><span><small>Continue</small><b>Watch product films</b></span><em>&#8594;</em></button><span class="sjwlt-hint" hidden></span></div>' +
        '<div class="sjwlt-film" role="tablist" aria-label="Product media"></div>';
      document.body.appendChild(lp);
      lpImg = lp.querySelector('img'); lpCap = lp.querySelector('.sjwlt-lp-cap'); lpFilm = lp.querySelector('.sjwlt-film');
      lpStage = lp.querySelector('.sjwlt-lp-stage'); lpHint = lp.querySelector('.sjwlt-hint'); lpX = lp.querySelector('.sjwlt-lp-x'); lpFilmCta = lp.querySelector('.sjwlt-lp-filmnext');

      /* image-save guard, same behavior as the theme popover */
      lp.addEventListener('contextmenu', function (e) { e.preventDefault(); }, true);
      lp.addEventListener('dragstart', function (e) { e.preventDefault(); }, true);

      lpX.addEventListener('click', closeLp);
      lpFilmCta.addEventListener('click', function (e) { e.stopPropagation(); openDesktopFilmsFromLoupe(); });
      lp.querySelectorAll('.sjwlt-arr').forEach(function (a) {
        a.addEventListener('click', function (e) { e.stopPropagation(); nav(parseInt(a.getAttribute('data-d'), 10)); });
      });

      /* -------- zoom + pan + pinch -------- */
      var pts = {}, pinch0 = 0, zoom0 = 1, dragging = false, moved = false, dx0 = 0, dy0 = 0, swipeId = null, swipeX0 = 0, swipeY0 = 0, lastTap = 0, lastTapX = 0, lastTapY = 0;
      function apply(cx, cy) {
        if (zoom <= 1) { zoom = 1; panX = panY = 0; lpImg.style.transform = ''; lpStage.classList.remove('z'); return; }
        lpStage.classList.add('z');
        if (cx != null) {
          var r = lpImg.getBoundingClientRect();
          lpImg.style.transformOrigin = ((cx - r.left) / r.width * 100) + '% ' + ((cy - r.top) / r.height * 100) + '%';
        }
        lpImg.style.transform = 'translate(' + panX + 'px,' + panY + 'px) scale(' + zoom + ')';
      }
      function hiRes() { var m = VIEW[lpIdx]; if (m && m.z && lpImg.src !== m.z) { lpImg.src = m.z; } }
      lpStage.addEventListener('wheel', function (e) {
        e.preventDefault();
        var steps = [1, 1.6, 2.4], i = steps.indexOf(zoom); if (i < 0) i = zoom > 1.6 ? 2 : (zoom > 1 ? 1 : 0);
        i += (e.deltaY < 0 ? 1 : -1); i = Math.max(0, Math.min(2, i));
        zoom = steps[i]; if (zoom > 1) hiRes(); apply(e.clientX, e.clientY);
      }, { passive: false });
      lpStage.addEventListener('pointerdown', function (e) {
        if (e.target.closest && e.target.closest('button')) return;
        pts[e.pointerId] = e; var ids = Object.keys(pts);
        if (ids.length === 2) { /* pinch begins */
          swipeId = null;
          var a = pts[ids[0]], b = pts[ids[1]];
          pinch0 = Math.hypot(a.clientX - b.clientX, a.clientY - b.clientY); zoom0 = zoom;
          lpImg.style.transformOrigin = '50% 50%'; lpStage.classList.add('nofx');
        } else if (zoom > 1) { dragging = true; moved = false; dx0 = e.clientX - panX; dy0 = e.clientY - panY; lpStage.classList.add('drag', 'nofx'); }
        else if (e.pointerType !== 'mouse') { swipeId = e.pointerId; swipeX0 = e.clientX; swipeY0 = e.clientY; }
        try { lpStage.setPointerCapture(e.pointerId); } catch (_e) {}
      });
      lpStage.addEventListener('pointermove', function (e) {
        if (!pts[e.pointerId]) return; pts[e.pointerId] = e; var ids = Object.keys(pts);
        if (ids.length === 2 && pinch0) {
          var a = pts[ids[0]], b = pts[ids[1]];
          var d = Math.hypot(a.clientX - b.clientX, a.clientY - b.clientY);
          zoom = Math.max(1, Math.min(3, zoom0 * d / pinch0)); if (zoom > 1) hiRes(); apply();
        } else if (dragging) { moved = true; panX = e.clientX - dx0; panY = e.clientY - dy0; apply(); }
      });
      function up(e) {
        var swipeDx = 0, swipeDy = 0, wasSwipePointer = swipeId === e.pointerId;
        if (wasSwipePointer) { swipeDx = e.clientX - swipeX0; swipeDy = e.clientY - swipeY0; swipeId = null; }
        delete pts[e.pointerId];
        if (!Object.keys(pts).length) { pinch0 = 0; lpStage.classList.remove('drag', 'nofx'); if (zoom <= 1.02) { zoom = 1; apply(); } }
        if (dragging) { dragging = false; if (moved) { moved = false; return; } }
        if (wasSwipePointer && zoom === 1 && Math.abs(swipeDx) > 48 && Math.abs(swipeDx) > Math.abs(swipeDy) * 1.15) {
          lastTap = 0; nav(swipeDx < 0 ? 1 : -1); return;
        }
        /* tap / click / double-tap (ignore clicks on buttons) */
        if (e.target.closest && e.target.closest('button')) return;
        var now = Date.now();
        if (now - lastTap < 320 && Math.abs(e.clientX - lastTapX) < 34 && Math.abs(e.clientY - lastTapY) < 34) {
          lastTap = 0; zoom = (zoom > 1) ? 1 : 2.4; if (zoom > 1) hiRes(); apply(e.clientX, e.clientY); return;
        }
        lastTap = now; lastTapX = e.clientX; lastTapY = e.clientY;
        if (e.pointerType === 'mouse') { zoom = (zoom > 1) ? 1 : 2.4; if (zoom > 1) hiRes(); apply(e.clientX, e.clientY); }
      }
      lpStage.addEventListener('pointerup', up);
      lpStage.addEventListener('pointercancel', function (e) { delete pts[e.pointerId]; pinch0 = 0; dragging = false; lpStage.classList.remove('drag', 'nofx'); });

      document.addEventListener('keydown', function (e) {
        if (!lp.classList.contains('open')) return;
        if (e.key === 'Escape') { closeLp(); }
        else if (e.key === 'ArrowRight') { nav(1); }
        else if (e.key === 'ArrowLeft') { nav(-1); }
        else if (e.key === 'Home') { go(0); }
        else if (e.key === 'End') { go(VIEW.length - 1); }
        else if (e.key === 'Tab') { /* focus trap */
          var f = lp.querySelectorAll('button'); if (!f.length) return;
          var first = f[0], last = f[f.length - 1];
          if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
          else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
        }
      });
    }
    function renderLp() {
      var m = VIEW[lpIdx]; if (!m) return;
      var paint = ++lpPaint;
      zoom = 1; panX = panY = 0; lpImg.style.transform = ''; lpStage.classList.remove('z');
      var thumb = m.t || m.m || m.z;
      var preview = m.m || m.g || thumb;
      var full = m.z || preview;
      var thumbRec = loadLpImage(thumb, 'high');
      var previewRec = loadLpImage(preview, 'high');
      var fullRec = loadLpImage(full, 'high');
      var quality = fullRec && fullRec.ready ? 2 : (previewRec && previewRec.ready ? 1 : 0);
      lpImg.src = quality === 2 ? full : (quality === 1 ? preview : thumb);
      function promote(rec, src, nextQuality) {
        if (!rec || nextQuality <= quality) return;
        rec.promise.then(function (ok) {
          if (!ok || paint !== lpPaint || VIEW[lpIdx] !== m || nextQuality <= quality) return;
          quality = nextQuality;
          lpImg.src = src;
        });
      }
      promote(thumbRec, thumb, 0);
      promote(previewRec, preview, 1);
      promote(fullRec, full, 2);
      lpImg.alt = (mainImg.alt || 'Photograph') + ' — view ' + (lpIdx + 1);
      lpCap.textContent = (lpIdx + 1) + ' of ' + VIEW.length;
      var canContinueToFilm = desk() && VM.length > 0 && lpIdx === VIEW.length - 1;
      lpFilmCta.hidden = !canContinueToFilm;
      if (canContinueToFilm) {
        if (lpHint && !lpHint.hidden) lpHint.style.opacity = '0';
        var filmLabel = VM.length + ' product film' + (VM.length === 1 ? '' : 's');
        lpFilmCta.querySelector('b').textContent = 'Watch ' + filmLabel;
        lpFilmCta.setAttribute('aria-label', 'Watch ' + filmLabel);
      }
      var lpNext = lp.querySelector('.sjwlt-arr[data-d="1"]');
      if (lpNext) lpNext.setAttribute('aria-label', canContinueToFilm ? 'Continue to product films' : 'Next photo');
      lpFilm.innerHTML = '';
      VIEW.forEach(function (mm, i) {
        var isFilm = mm.k === 'video';
        var b = el('button', (i === lpIdx ? 'on' : '') + (isFilm ? ' sjwlt-film-video' : ''));
        b.type = 'button'; b.setAttribute('role', 'tab'); b.setAttribute('aria-selected', i === lpIdx ? 'true' : 'false');
        b.setAttribute('aria-label', (isFilm ? 'Product film ' : 'Photograph ') + (i + 1) + ' of ' + VIEW.length);
        b.appendChild(Object.assign(el('img'), { src: mm.t, alt: '', draggable: false }));
        b.addEventListener('click', function () { go(i); });
        lpFilm.appendChild(b);
      });
      var on = lpFilm.querySelector('.on'); if (on && on.scrollIntoView) { try { on.scrollIntoView({ inline: 'center', block: 'nearest' }); } catch (_e) {} }
      primeLpAround(lpIdx);
    }
    function openMobileFilmFromLoupe(m) {
      var filmIndex = VM.indexOf(m);
      closeLp();
      requestAnimationFrame(function () {
        var buttons = document.querySelectorAll('.sjwpp-gth-video');
        if (buttons[filmIndex]) buttons[filmIndex].click();
        else openVideoPlayer(m, filmIndex);
      });
    }
    function openDesktopFilmsFromLoupe() {
      if (!VM.length) return;
      var returnFocus = lastFocus;
      vpReturnPhoto = VIEW[lpIdx] && VIEW[lpIdx].k !== 'video' ? VIEW[lpIdx] : (SET[idxOfStage()] || SET[0] || null);
      lp.classList.remove('open');
      document.documentElement.classList.remove('sjw-photo-viewer-open');
      document.body.style.overflow = '';
      requestAnimationFrame(function () {
        openVideoPlayer(VM[0], 0);
        vpLastFocus = returnFocus;
      });
    }
    function go(i) {
      lpIdx = Math.max(0, Math.min(i, VIEW.length - 1));
      if (!desk() && VIEW[lpIdx] && VIEW[lpIdx].k === 'video') { openMobileFilmFromLoupe(VIEW[lpIdx]); return; }
      renderLp();
    }
    function nav(d) {
      if (d > 0 && desk() && VM.length && lpIdx === VIEW.length - 1) { openDesktopFilmsFromLoupe(); return; }
      go(lpIdx + d);
    }
    function openLp(i) {
      buildLp();
      /* The viewer opens on the media already being viewed. On mobile, films join the
         same rotated sequence so a shopper starting on any photograph can swipe all
         the way into the product films. Desktop keeps its separate film presentation. */
      var _photosStart = idxOfStage();
      var _base = desk() ? SET.slice() : SET.concat(VM);
      var _want = SET[Math.max(0, Math.min(i || 0, SET.length - 1))];
      var _start = Math.max(0, _base.indexOf(SET[_photosStart]));
      VIEW = _base.slice(_start).concat(_base.slice(0, _start));
      lpIdx = Math.max(0, VIEW.indexOf(_want));
      lastFocus = document.activeElement;
      renderLp();
      lp.classList.add('open');
      document.documentElement.classList.add('sjw-photo-viewer-open');
      document.body.style.overflow = 'hidden';
      lpX.focus();
      if (!hintShown) {
        hintShown = true;
        if (!lpFilmCta || lpFilmCta.hidden) {
          lpHint.hidden = false;
          lpHint.textContent = ('ontouchstart' in window) ? 'Swipe to browse · pinch to zoom' : 'Click to magnify · scroll to step zoom';
          lpHint.style.opacity = '1';
          setTimeout(function () { lpHint.style.opacity = '0'; }, 2800);
        }
      }
    }
    function closeLp() {
      lp.classList.remove('open');
      document.documentElement.classList.remove('sjw-photo-viewer-open');
      document.body.style.overflow = '';
      if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (_e) {} }
    }

    /* stage → Loupe (capture beats the theme popover), swipe-aware, keyboard-complete */
    var swiped = false, tX = 0;
    stage.addEventListener('touchstart', function (e) { if (stage.classList.contains('sjwpp-stage--video')) return; tX = e.touches[0].clientX; }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (stage.classList.contains('sjwpp-stage--video')) return;
      if (Math.abs(e.changedTouches[0].clientX - tX) > 40) { swiped = true; setTimeout(function () { swiped = false; }, 400); }
    }, { passive: true });
    stage.addEventListener('click', function (e) {
      if (stage.classList.contains('sjwpp-stage--video') || (e.target.closest && e.target.closest('video,iframe'))) return;
      if (swiped) return;
      e.preventDefault(); e.stopImmediatePropagation();
      openLp(idxOfStage());
    }, true);
    var stageCount = stage.querySelector('[data-sjwpp-gcount]');
    var stagePosition = stageCount && stageCount.textContent ? ', ' + stageCount.textContent.trim() : '';
    stage.setAttribute('role', 'button'); stage.setAttribute('tabindex', '0'); stage.setAttribute('aria-label', 'Open photo viewer' + stagePosition);
    stage.addEventListener('keydown', function (e) {
      if (stage.classList.contains('sjwpp-stage--video')) return;
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openLp(idxOfStage()); }
    });
    function idxOfStage() {
      var s = mainImg.getAttribute('src') || '';
      for (var i = 0; i < SET.length; i++) { if (SET[i].m === s || SET[i].t === s || SET[i].z === s || SET[i].g === s) return i; }
      return 0;
    }

    /* hero crossfade — the theme hard-swaps [data-sjwpp-mainimg].src on karat/metal/variant
       changes; a ghost of the outgoing photo holds on top until the incoming one has
       loaded, then fades. Pure overlay: theme paint path (_paintTok, sbimg) untouched. */
    (function () {
      if (RM) return;
      var ghost = null, busy = false, armedAt = 0;
      var prev = mainImg.currentSrc || mainImg.src;
      function ensure() {
        if (ghost) return ghost;
        ghost = el('img', 'sjwlt-ghost');
        ghost.alt = ''; ghost.setAttribute('aria-hidden', 'true'); ghost.draggable = false;
        stage.appendChild(ghost);
        return ghost;
      }
      function fadeOut() {
        if (!ghost || !busy) return;
        busy = false;
        ghost.style.transition = 'opacity .34s ' + EASE;
        ghost.style.opacity = '0';
      }
      new MutationObserver(function () {
        var now = mainImg.currentSrc || mainImg.src;
        var old = prev; prev = now;
        if (!old || old === now) return;
        if (stage.classList.contains('sjwpp-loading')) return; /* blur-up first paint */
        if (busy) return; /* rapid double-swap (set reset + variant) — keep the first outgoing frame */
        var g = ensure();
        g.src = old;
        g.style.transition = 'none'; g.style.opacity = '1';
        void g.offsetWidth;
        busy = true; armedAt = Date.now();
        if (mainImg.complete && mainImg.naturalWidth) { requestFade(); }
        else { mainImg.addEventListener('load', requestFade, { once: true }); }
        setTimeout(fadeOut, 1200); /* safety: never hold the old frame forever */
      }).observe(mainImg, { attributes: true, attributeFilter: ['src'] });
      function requestFade() {
        /* let the incoming frame commit before revealing it */
        var wait = Math.max(0, 120 - (Date.now() - armedAt));
        setTimeout(fadeOut, wait);
      }
    })();

    /* ================= DESKTOP LIGHT TABLE ================= */
    var cap = null, mosaic = null, lessRow = null, live = null, expanded = false, built = false;
    function buildLT() {
      if (built || !desk()) return;
      built = true;
      cap = el('div', 'sjwlt-cap',
        '<span class="sjwlt-cap-l"><span class="sjwlt-dot"></span><span class="sjwlt-cap-m"></span></span><span class="sjwlt-cap-r"></span>');
      mosaic = el('div', 'sjwlt-mosaic');
      lessRow = el('div', 'sjwlt-less', '<button type="button">Show less</button>');
      lessRow.hidden = true;
      lessRow.querySelector('button').addEventListener('click', function () {
        expanded = false; renderMosaic(false); lessRow.hidden = true;
        try { gcol.scrollIntoView({ block: 'start', behavior: RM ? 'auto' : 'smooth' }); } catch (_e) {}
      });
      live = el('span', 'sjwlt-live'); live.setAttribute('aria-live', 'polite');
      gal.insertAdjacentElement('afterend', cap);
      cap.insertAdjacentElement('afterend', mosaic);
      mosaic.insertAdjacentElement('afterend', lessRow);
      gcol.appendChild(live);
      gcol.classList.remove('sjwpp-tileson'); /* legacy saved 'tiles' view would hide the stage under the light table */
      gcol.classList.add('sjw-lt-on');
      if (bcol) { bcol.classList.add('sjw-lt-buy'); stickyFit(); window.addEventListener('resize', stickyFit, { passive: true }); }
      renderMosaic(false);
      syncCap();
    }
    function stickyFit() {
      if (!bcol) return;
      var h = bcol.getBoundingClientRect().height;
      var top = Math.min(110, window.innerHeight - h - 28);
      bcol.style.setProperty('--sjwlt-top', Math.round(top) + 'px');
    }
    function syncCap() {
      if (!cap) return;
      VARIANT_LINKED = !!(G.state && G.state().variantMediaLinked);
      var lbl = metalLabel();
      var mtxt = cap.querySelector('.sjwlt-cap-m');
      var dot = cap.querySelector('.sjwlt-dot');
      if (!VARIANT_LINKED) {
        /* Signora (2 Nov 2026): no photo is tied to a metal here, so they can show any finish. The chosen metal is
           already named beside the price, so the caption stays short enough for one line. */
        mtxt.textContent = lbl ? 'Photos may show another metal' : 'Product photographs';
        dot.style.display = 'none';
      } else {
        /* Signora (2 Nov 2026): only say "Shown in <metal>" when every photo in view is tagged with that metal.
           Untagged photos (no metal in the file name) can show another gold colour. */
        var st0 = G.state ? G.state() : {};
        var mixed = HONEST && st0.color && !st0.all && SET.some(function (m) { return !m.c; });
        mtxt.textContent = HONEST
          ? (lbl ? (mixed ? 'Some photos may show another metal' : 'Shown in ' + lbl) : 'The photographs')
          : 'Photographed in another finish — crafted in ' + (lbl || 'your metal');
        dot.style.display = mixed && lbl ? 'none' : '';
        dot.style.background = metalDotColor();
      }
      cap.querySelector('.sjwlt-cap-r').textContent = SET.length + (SET.length === 1 ? ' photograph' : ' photographs') + (VM.length ? ' · ' + VM.length + (VM.length === 1 ? ' film' : ' films') : '');
      if (live) live.textContent = !VARIANT_LINKED
        ? 'Showing ' + SET.length + ' product photographs'
        : 'Showing ' + SET.length + ' photographs' + (HONEST && lbl ? ' in ' + lbl : ' in another finish');
    }
    function frame(m, setIdx, total) {
      var b = el('button', 'sjwlt-fr' + (m.ar >= 1.3 ? ' sjwlt-wide' : ''));
      b.type = 'button';
      b.setAttribute('aria-label', 'View photograph ' + (setIdx + 1) + ' of ' + total);
      var im = el('img');
      im.src = m.g || m.m; im.loading = 'lazy'; im.decoding = 'async'; im.alt = ''; im.draggable = false;
      b.appendChild(im);
      /* Signora (2 Nov 2026): a photo tagged with another metal says so on the photo. */
      var stF = G.state ? G.state() : {};
      var MN = { Y: 'yellow gold', W: 'white metal', R: 'rose gold' };
      if (m.c && stF.color && m.c !== stF.color && MN[m.c]) b.appendChild(el('span', 'sjw-pm-chip', 'Shown in ' + MN[m.c]));
      b.addEventListener('click', function () { openLp(setIdx); });
      return b;
    }
    var SHOW_MIN = 4;
    function renderMosaic(animIn) {
      if (!mosaic) return;
      /* The mosaic sits under the theme's stage, so it must skip whatever photo the
         stage is CURRENTLY showing — not blindly SET[0]. After a metal/variant click
         the stage moves, and the old slice(1) both duplicated the hero and hid the
         real first photo. Owner-reported, fixed 2026-07-29. */
      var _heroIdx = idxOfStage();
      var rest = SET.filter(function (_m, _i) { return _i !== _heroIdx; });
      var show = expanded ? rest.length : Math.min(SHOW_MIN, rest.length);
      var hidden = rest.length - show;
      if (hidden < 2 && !expanded) { show = rest.length; hidden = 0; }
      mosaic.innerHTML = '';
      rest.slice(0, show).forEach(function (m) { mosaic.appendChild(frame(m, SET.indexOf(m), SET.length)); });
      if (hidden > 0 && !expanded) {
        var more = el('button', 'sjwlt-more',
          '<img alt="" draggable="false"><span class="sjwlt-more-scrim"><span class="sjwlt-more-n">+' + hidden + '</span><span class="sjwlt-more-t">photographs</span></span>');
        more.type = 'button';
        more.setAttribute('aria-label', 'Show ' + hidden + ' more photographs');
        more.querySelector('img').src = rest[show].t;
        more.addEventListener('click', function () { expanded = true; renderMosaic(true); lessRow.hidden = false; });
        mosaic.appendChild(more);
      }
      if (VM.length > 1) mosaic.appendChild(videoCollection(VM));
      else if (VM.length === 1) mosaic.appendChild(videoFrame(VM[0], 0, 1));
      if (animIn && !RM) { stagger(mosaic.querySelectorAll('.sjwlt-fr,.sjwlt-more,.sjwlt-vfr')); }
      if (built) stickyFit();
    }
    function stagger(cells) {
      [].forEach.call(cells, function (c, i) {
        c.style.opacity = '0'; c.style.transform = 'translateY(10px)';
        void c.offsetWidth; /* forced reflow — final state must land without rAF */
        setTimeout(function () {
          c.style.transition = 'opacity .34s ' + EASE + ',transform .34s ' + EASE;
          c.style.opacity = '1'; c.style.transform = 'none';
        }, 40 * Math.min(i, 8) + 30);
        setTimeout(function () { c.style.transition = ''; c.style.opacity = ''; c.style.transform = ''; }, 40 * Math.min(i, 8) + 480);
      });
    }

    /* Stage photo changes (thumbnail / karat / variant) must re-plate the mosaic too,
       otherwise the previously-excluded hero stays hidden and the new one duplicates. */
    (function () {
      if (!mainImg || !window.MutationObserver) return;
      var lastSrc = mainImg.getAttribute('src') || '';
      new MutationObserver(function () {
        var s = mainImg.getAttribute('src') || '';
        if (s === lastSrc) return;
        lastSrc = s;
        if (built && !(lp && lp.classList.contains('open'))) renderMosaic(false);
      }).observe(mainImg, { attributes: true, attributeFilter: ['src'] });
    })();

    /* ---------- metal re-plate ---------- */
    var lastKey = setKey();
    document.addEventListener('sjw:gal', function (e) {
      if (!e.detail || e.detail.fn !== 'showColor') return;
      computeSet();
      var key = setKey();
      if (key === lastKey) { syncCap(); return; } /* same photographs (karat change) — caption only, no re-plate flash */
      lastKey = key;
      if (lp && lp.classList.contains('open')) { go(lpIdx); } /* remap open Loupe (go clamps) */
      if (!built) return;
      expanded = false; lessRow.hidden = true;
      if (RM) { renderMosaic(false); syncCap(); return; }
      var olds = mosaic.querySelectorAll('.sjwlt-fr img');
      [].forEach.call(olds, function (im) {
        im.style.transition = 'opacity .14s ease,transform .14s ease';
        im.style.opacity = '.35'; im.style.transform = 'translateX(-6px)';
      });
      setTimeout(function () {
        renderMosaic(false); syncCap();
        var imgs = mosaic.querySelectorAll('.sjwlt-fr img');
        [].forEach.call(imgs, function (im, i) {
          im.style.opacity = '.35'; im.style.transform = 'translateX(6px)';
          void im.offsetWidth;
          setTimeout(function () {
            im.style.transition = 'opacity .28s ' + EASE + ',transform .28s ' + EASE;
            im.style.opacity = '1'; im.style.transform = 'none';
          }, 40 * Math.min(i, 6));
          setTimeout(function () { im.style.transition = ''; im.style.opacity = ''; im.style.transform = ''; }, 40 * Math.min(i, 6) + 380);
        });
      }, 150);
    });
    document.addEventListener('sjw:galvariant', function (e) {
      VARIANT_LINKED = !!(e.detail && e.detail.linked);
      syncCap();
    });

    /* build now (desktop) or when the viewport grows into desktop */
    if (desk()) { buildLT(); }
    else {
      var onR = function () { if (desk()) { buildLT(); window.removeEventListener('resize', onR); } };
      window.addEventListener('resize', onR, { passive: true });
    }
  }
})();
